module.exports = __webpack_public_path__ + "static/media/citroen.994c27ad.png";